var map = {
  "./shape-triangle-aquamarine-gradient.png": "17839",
  "./shape-triangle-aquamarine-light.png": "50979",
  "./shape-triangle-aquamarine.png": "88961",
  "./shape-triangle-blue-gradient.png": "13590",
  "./shape-triangle-blue-light.png": "90432",
  "./shape-triangle-blue.png": "86436",
  "./shape-triangle-cyan-gradient.png": "47695",
  "./shape-triangle-cyan-light.png": "90898",
  "./shape-triangle-cyan.png": "40892",
  "./shape-triangle-green-gradient.png": "55319",
  "./shape-triangle-green-light.png": "95680",
  "./shape-triangle-green.png": "48270",
  "./shape-triangle-grey100.png": "9905",
  "./shape-triangle-grey1000.png": "20960",
  "./shape-triangle-grey200.png": "79825",
  "./shape-triangle-grey25.png": "29490",
  "./shape-triangle-grey300.png": "13764",
  "./shape-triangle-grey400.png": "62077",
  "./shape-triangle-grey50.png": "81161",
  "./shape-triangle-grey500.png": "82000",
  "./shape-triangle-grey600.png": "28148",
  "./shape-triangle-grey700.png": "82761",
  "./shape-triangle-grey800.png": "71702",
  "./shape-triangle-grey900.png": "5206",
  "./shape-triangle-indigo-gradient.png": "14861",
  "./shape-triangle-indigo-light.png": "70985",
  "./shape-triangle-indigo.png": "91609",
  "./shape-triangle-lime-gradient.png": "48890",
  "./shape-triangle-lime-light.png": "77482",
  "./shape-triangle-lime.png": "20402",
  "./shape-triangle-magenta-gradient.png": "90108",
  "./shape-triangle-magenta-light.png": "76602",
  "./shape-triangle-magenta.png": "311",
  "./shape-triangle-navy-gradient.png": "20187",
  "./shape-triangle-navy-light.png": "57650",
  "./shape-triangle-navy.png": "55216",
  "./shape-triangle-orange-gradient.png": "11271",
  "./shape-triangle-orange-light.png": "28153",
  "./shape-triangle-orange.png": "21491",
  "./shape-triangle-purple-gradient.png": "60158",
  "./shape-triangle-purple-light.png": "479",
  "./shape-triangle-purple.png": "86114",
  "./shape-triangle-red-gradient.png": "17824",
  "./shape-triangle-red-light.png": "96462",
  "./shape-triangle-red.png": "21553",
  "./shape-triangle-yellow-gradient.png": "48671",
  "./shape-triangle-yellow-light.png": "50343",
  "./shape-triangle-yellow.png": "39226"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52440;
